'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templateObject = _taggedTemplateLiteral(['\n  .radioButton {\n    margin-right: ', ';\n    margin-left: ', ';\n    margin-bottom: ', ';\n    display: ', ';\n  }\n'], ['\n  .radioButton {\n    margin-right: ', ';\n    margin-left: ', ';\n    margin-bottom: ', ';\n    display: ', ';\n  }\n']);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _RadioButtonGroupBase = require('./RadioButtonGroupBase');
var _RadioButtonGroupBase2 = _interopRequireDefault(_RadioButtonGroupBase);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var RadioButtonGroup = (0, _styledComponents2['default'])(_RadioButtonGroupBase2['default'])(_templateObject, function (props) {
  return props.layout === 'horizontal' ? '8px' : '0px';
}, function (props) {
  return props.layout === 'horizontal' ? '8px' : '0px';
}, function (props) {
  return props.layout !== 'horizontal' ? '8px' : null;
}, function (props) {
  return props.layout !== 'horizontal' ? 'block' : 'inline';
});
RadioButtonGroup.propTypes = {
  layout: _propTypes2['default'].oneOf(['vertical', 'horizontal'])
};
exports['default'] = RadioButtonGroup;